import React from 'react';
import { Box, Typography, useMediaQuery } from '@mui/material';
import { Helmet } from 'react-helmet';
import config from '../common/config';
import { Theme } from '../types';
import ReturnHomeButton from './ReturnHomeButton';
import ThemePreferenceIconButton from './ThemePreferenceIconButton';
import StatusPageFooter from './StatusPageFooter';
import { useHideAppHeaderAndPrompts } from '../contexts/AppHeaderAndPromptsVisibilityContext';

type StatusPageLayoutProps = {
	pageTitle: string;
	imageSrc: string;
	title: string;
	description: string;
};

/** Full-page message: the illustration stands on a paper-coloured floor that fills the rest of the page. */
const StatusPageLayout = ({ pageTitle, imageSrc, title, description }: StatusPageLayoutProps) => {
	useHideAppHeaderAndPrompts();
	const isMdUp = useMediaQuery((theme: Theme) => theme.breakpoints.up('md'));
	const message = (
		<Box display='flex' flexDirection='column' alignItems={isMdUp ? 'flex-start' : 'center'} gap={2} textAlign={isMdUp ? 'left' : 'center'}>
			<Typography variant='h4'>{title}</Typography>
			<Typography variant='body2' color='text.secondary'>
				{description}
			</Typography>
			<ReturnHomeButton />
		</Box>
	);
	return (
		<>
			<Helmet>
				<title>{pageTitle} - {config.appName}</title>
			</Helmet>
			<Box flex={1} display='flex' flexDirection='column' position='relative'>
				<Box position='absolute' top={8} right={8}>
					<ThemePreferenceIconButton />
				</Box>
				<Box flex={1} display='flex' justifyContent='center' alignItems='flex-end' px={2}>
					<Box display='flex' alignItems='center' gap={6}>
						<Box component='img' src={imageSrc} alt='' sx={{ height: { xs: 280, md: 400 }, mb: isMdUp ? -7 : -5, zIndex: 10, display: 'block' }} />
						{isMdUp && message}
					</Box>
				</Box>
				<Box flex={1} display='flex' flexDirection='column' bgcolor='background.paper' px={{ xs: 2, md: 4 }} pt={3}>
					{!isMdUp && message}
					<Box mt='auto' pt={3}>
						<StatusPageFooter />
					</Box>
				</Box>
			</Box>
		</>
	);
};

export default StatusPageLayout;
